// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%27100%25%27 height=%2732%27%3E%3Crect x=%270.5%27 y=%270.5%27 width=%27calc%28100%25 - 1px%29%27 height=%2731%27 rx=%2715%27 fill=%27none%27 stroke=%27%23d4d4e0%27 stroke-width=%271%27 stroke-dasharray=%274 6%27 stroke-linecap=%27round%27 pathLength=%27240%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%27100%25%27 height=%2732%27%3E%3Crect x=%270.5%27 y=%270.5%27 width=%27calc%28100%25 - 1px%29%27 height=%2731%27 rx=%2715%27 fill=%27none%27 stroke=%27%23282863%27 stroke-width=%271%27 stroke-dasharray=%274 6%27 stroke-linecap=%27round%27 pathLength=%27240%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HNqz5,.kRDov.Jof0F,.kRDov:active:not(:disabled),.kRDov:hover:not(:disabled):not(:active){color:#282863;border-color:#282863}.kRDov{box-sizing:border-box;display:inline-flex;flex-direction:row;justify-content:center;align-items:center;border-radius:16px;border:1px solid;color:#696992;border-color:#d4d4e0;background:#fff;height:32px;padding:8px 16px;font-size:var(--font-size-p2, 12px);line-height:var(--line-height-p2, 16px);letter-spacing:.02em;font-family:"Lufga-Regular";font-weight:400}.kRDov:not(:disabled){cursor:pointer}.kRDov:disabled{opacity:.5;cursor:default}.kRDov .MTFZr{margin-inline-start:4px}.kRDov.WjpKc{width:100%;justify-content:space-between}.kRDov.RYzOp{background-color:#f4f4f7;border:none;border-radius:4px;padding:8px 12px;color:var(--text-secondary, #696992)}.kRDov.RYzOp:hover:not(:disabled),.kRDov.RYzOp:active:not(:disabled),.kRDov.RYzOp.Jof0F:not(:disabled){background-color:#d4d4e0;color:var(--text-standard, #282863)}.kRDov.yU7sf{background:#fcfcfd;border:none;border-radius:9999px;padding:0 12px 0 16px;gap:4px;position:relative}.kRDov.yU7sf::before{content:"";position:absolute;inset:0;border-radius:inherit;pointer-events:none;background-image:url(${___CSS_LOADER_URL_REPLACEMENT_0___});background-size:100% 100%;background-repeat:no-repeat}.kRDov.yU7sf:hover:not(:disabled):not(:active)::before,.kRDov.yU7sf:active:not(:disabled)::before,.kRDov.yU7sf.Jof0F:not(:disabled)::before{background-image:url(${___CSS_LOADER_URL_REPLACEMENT_1___})}.kRDov.yU7sf.Jof0F:disabled{color:#696992}.kRDov.yU7sf .MTFZr{margin-inline-start:0}.MTFZr{display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blue45": `#fcfcff`,
	"blue48": `#f5f7fd`,
	"blue50": `#f3f5ff`,
	"blue300": `#dae0ff`,
	"blue500": `#c0caff`,
	"blue600": `#a1aef5`,
	"blue700": `#8296ff`,
	"blue800": `#6176e7`,
	"dark50": `#fcfcfd`,
	"dark70": `#f4f4f7`,
	"dark100": `#eaeaef`,
	"dark120": `#e4e4ec`,
	"dark200": `#d4d4e0`,
	"dark300": `#bfbfd0`,
	"dark400": `#a9a9c1`,
	"dark500": `#9393b1`,
	"dark600": `#7e7ea1`,
	"dark700": `#696992`,
	"dark800": `#535382`,
	"dark900": `#282863`,
	"green45": `#eff6fa`,
	"green50": `#f3fcfa`,
	"green300": `#b6ebdf`,
	"green500": `#86ddca`,
	"green700": `#56d0b5`,
	"green800": `#36b89b`,
	"green900": `#089475`,
	"orange50": `#fdf2dc`,
	"orange300": `#fadea8`,
	"orange500": `#f9d797`,
	"orange700": `#f7ca75`,
	"orange800": `#f5bd52`,
	"orange900": `#dd9306`,
	"purple50": `#e1d9fe`,
	"purple100": `#dad0fe`,
	"purple300": `#c3b3fc`,
	"purple400": `#b4a1fc`,
	"purple500": `#a58efb`,
	"purple700": `#8768f9`,
	"purple800": `#6942f8`,
	"purple900": `#4520cc`,
	"red200": `#fdf0f0`,
	"red300": `#fee3e3`,
	"red500": `#f9d5d5`,
	"red700": `#f3aaaa`,
	"red900": `#eb7272`,
	"red950": `#e86161`,
	"red970": `#dd4c4c`,
	"white": `#fff`,
	"chartBlue": `#6a9ff0`,
	"chartPeach": `#fbd499`,
	"chartCyan": `#a9e5f2`,
	"chartPink": `#fda5ef`,
	"defaultTextStandard": `#282863`,
	"defaultTextSecondary": `#696992`,
	"defaultButtonPrimary": `#6942f8`,
	"buttonPrimary": `var(--button-primary, #6942f8)`,
	"buttonPrimaryDark": `var(--button-primary-dark, #4520cc)`,
	"buttonDisabled": `var(--button-disabled, #bfbfd0)`,
	"buttonDisabledDark": `var(--button-disabled-dark, #a9a9c1)`,
	"defaultButtonDisabled": `#bfbfd0`,
	"defaultStepperCompleted": `#089475`,
	"defaultStepperIncomplete": `#d4d4e0`,
	"defaultButtonSecondary": `#fcfcfd`,
	"defaultBgStandard": `#f3f5ff`,
	"defaultBgLight": `#fff`,
	"sh10": `0px 4px 12px rgba(40,40,99,.06)`,
	"sh20": `0px 4px 16px rgba(40,40,99,.08)`,
	"sh40": `0px 4px 24px rgba(40,40,99,.12)`,
	"sh60": `0px 4px 14px rgba(40,40,99,.24)`,
	"fontFamilyLight": `"Lufga-Regular"`,
	"fontFamilyNormal": `"Lufga-Medium"`,
	"fontFamilyBold": `"Lufga-SemiBold"`,
	"fontSizeH1": `var(--font-size-h1, 40px)`,
	"fontSizeH2": `var(--font-size-h2, 36px)`,
	"fontSizeH3": `var(--font-size-h3, 28px)`,
	"fontSizeH4": `var(--font-size-h4, 24px)`,
	"fontSizeH5": `var(--font-size-h5, 20px)`,
	"fontSizeH6": `var(--font-size-h6, 18px)`,
	"fontSizeP1": `var(--font-size-p1, 14px)`,
	"fontSizeP2": `var(--font-size-p2, 12px)`,
	"fontSizeP3": `var(--font-size-p3, 10px)`,
	"lineHeightH1": `var(--line-height-h1, 56px)`,
	"lineHeightH2": `var(--line-height-h2, 52px)`,
	"lineHeightH3": `var(--line-height-h3, 36px)`,
	"lineHeightH4": `var(--line-height-h4, 34px)`,
	"lineHeightH5": `var(--line-height-h5, 32px)`,
	"lineHeightH6": `var(--line-height-h6, 30px)`,
	"lineHeightP1": `var(--line-height-p1, 22px)`,
	"lineHeightP2": `var(--line-height-p2, 16px)`,
	"lineHeightP3": `var(--line-height-p3, 14px)`,
	"highlightMixin": `HNqz5`,
	"root": `kRDov`,
	"highlight": `Jof0F`,
	"suffixIcon": `MTFZr`,
	"fullWidth": `WjpKc`,
	"subtle": `RYzOp`,
	"ghost": `yU7sf`
};
export default ___CSS_LOADER_EXPORT___;
